// Ensure that updates here are also reflected in /src/scss/responsive/_variable.scss
const BREAKPOINTS = {
  XS: 359,
  SM: 743,
  TABLET: 767,
  MD: 1050,
  LG: 1279,
  XL: 1360
};
export default BREAKPOINTS;
